import React from 'react';

import ExternalPublication from '../../../components/Molecules/ExternalPublication';

const NodeExternalPublication = ({ entity, className }) => (
  <ExternalPublication
    className={className}
    year={entity.getIn(['field_year', 0, 'value'])}
    authors={entity.getIn(['field_naam_auteur', 0, 'value'])}
    title={entity.getIn(['title', 0, 'value'], '')}
    link={entity.getIn(['field_link', 0, 'uri'])}
  />
);

export default NodeExternalPublication;
